export const MARGIN_TOP = 'margin-top: 16px';
